import * as React from 'react';
import MerchantCategory from '../../../../domain/entities/MerchantCategory';
import css from './ExploreSuggestCategories.module.scss';

interface Props {
  categories: MerchantCategory[];
  handleClick: (cat: MerchantCategory) => void;
}

class ExploreSuggestCategories extends React.PureComponent<Props> {
  public static defaultProps: Props = {
    categories: [],
    handleClick: (_: MerchantCategory) => undefined,
  };

  constructor(props: Props) {
    super(props);

    this.handleClick = this.handleClick.bind(this);
  }

  private handleClick(ev: React.MouseEvent, cat: MerchantCategory) {
    ev.preventDefault();

    this.props.handleClick(cat);
  }

  public render() {
    return (
      <ul className={css.ExploreSuggestCategories}>
        {this.props.categories.map(cat => {
          return (
            <li key={cat.id} className={css.ExploreSuggestCategories__Item}>
              <a href="" onClick={ev => this.handleClick(ev, cat)}>
                {cat.nameJA}
              </a>
            </li>
          );
        })}
      </ul>
    );
  }
}

export default ExploreSuggestCategories;
